import {
	createApiFactory,
	createComponentExtension,
	createPlugin,
	discoveryApiRef,
	fetchApiRef,
} from '@backstage/core-plugin-api';
import { TeamMetadataClient, teamMetadataApiRef } from './api/TeamMetadataApi';

export const teamMetadataPlugin = createPlugin({
	id: 'team-metadata',
	apis: [
		createApiFactory({
			api: teamMetadataApiRef,
			deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
			factory: ({ discoveryApi, fetchApi }) =>
				new TeamMetadataClient({ discoveryApi, fetchApi }),
		}),
	],
});

export const EntityTeamMetadataCard = teamMetadataPlugin.provide(
	createComponentExtension({
		name: 'EntityTeamMetadataCard',
		component: {
			lazy: () =>
				import('./components/TeamMetadataCard').then(
					m => m.EntityTeamMetadataCard,
				),
		},
	}),
);
